import { render, staticRenderFns } from "./BaseAccordion.vue?vue&type=template&id=6ab88445&scoped=true"
import script from "./BaseAccordion.vue?vue&type=script&lang=js"
export * from "./BaseAccordion.vue?vue&type=script&lang=js"
import style0 from "./BaseAccordion.vue?vue&type=style&index=0&id=6ab88445&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ab88445",
  null
  
)

export default component.exports